import React, { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
  };

  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current);
    setShowMenu(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setShowMenu(false);
    }, 150);
  };

  return (
    <nav className="bg-white text-gray-900 px-6 py-3 shadow-md">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center space-x-3">
          <Link to="/">
            <img src="/OPGameTrackerLogo.png" alt="OP Game Tracker Logo" className="h-20 w-auto" />
          </Link>
          <span className="text-4xl font-bold hidden sm:inline">Game Tracker</span>
        </div>

        {/* Nav links */}
        <div className="flex items-center space-x-6 relative">
          <Link to="/calendar" className="hover:text-blue-400 hidden md:inline">Calendar</Link>
          <Link to="/my-games" className="hover:text-blue-400 hidden md:inline">My Games</Link>

          {/* Profile dropdown */}
          {token && user ? (
            <div
              className="relative"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <button className="text-2xl hover:text-blue-600" title="Profile" aria-label="Profile">
                👤
              </button>
              {showMenu && (
                <div className="absolute right-0 mt-2 w-48 bg-white text-gray-900 rounded shadow z-50">
                  <Link
                    to="/profile"
                    className="block px-4 py-2 hover:bg-gray-100"
                    onClick={() => setShowMenu(false)}
                  >
                    Profile Dashboard
                  </Link>
                  <button
                    onClick={handleLogout}
                    className="w-full text-left px-4 py-2 hover:bg-gray-100"
                  >
                    Log Out
                  </button>
                </div>
              )}
            </div>
          ) : (
            <Link to="/login" className="hover:text-blue-600 text-2xl" title="Login">
              👤
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
